import { useTranslator } from '@bluebeam/react-i18n';
import { Button } from '@bluebeam/react-skyline-button';
import ChevronLeft from 'components/Icons/ChevronLeft';
import React, { FC } from 'react';

type ButtonProps = {
  onBackClick?: () => void;
};

const BackButton: FC<ButtonProps> = ({ onBackClick }) => {
  const { translate } = useTranslator(['buttons']);

  return (
    <div className="pb2" css={{ fontFamily: 'Roboto' }}>
      <Button
        className="font-size-5 flex-start  flex cursor-pointer items-center px-0 hover:bg-primary-blue/0 hover:text-primary-blue"
        onClick={onBackClick}
        type="button"
        variant="text"
        data-analytics="disciplines-page-back-btn"
        id="disciplines-page-back-btn"
      >
        <ChevronLeft width="9px" height="16px" />
        <span className="ml-2 text-primary-blue">
          {translate('buttons:back')}
        </span>
      </Button>
    </div>
  );
};

export default BackButton;
